import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var RecipesOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M0.833252 3.3335V15.0002C0.833252 15.921 1.57909 16.6668 2.49992 16.6668H3.33325V15.0002H2.49992V5.00016H8.33325C8.79242 5.00016 9.16659 5.37433 9.16659 5.8335V15.0002H8.33325V16.6668C8.33325 17.5877 9.07909 18.3335 9.99992 18.3335C10.9208 18.3335 11.6666 17.5877 11.6666 16.6668H17.4999C18.4208 16.6668 19.1666 15.921 19.1666 15.0002V3.3335H11.6666C11.0233 3.3335 10.4433 3.58374 9.99992 3.98291C9.55659 3.58374 8.97659 3.3335 8.33325 3.3335H0.833252ZM11.6666 5.00016H17.4999V15.0002H10.8333V5.8335C10.8333 5.37433 11.2074 5.00016 11.6666 5.00016ZM5.83325 5.8335C4.41659 5.8335 3.33325 8.5835 3.33325 10.0002C3.33325 11.1205 4.01579 12.0229 4.99992 12.3553V18.3335H6.66659V12.3553C7.65072 12.0229 8.33325 11.1205 8.33325 10.0002C8.33325 8.5835 7.24992 5.8335 5.83325 5.8335ZM11.6666 6.66683V8.3335H16.6666V6.66683H11.6666ZM11.6666 10.8335V12.5002H16.6666V10.8335H11.6666Z",
    fill: fill
  }));
};
export { RecipesOutline as default };
//# sourceMappingURL=RecipesOutline.js.map
